
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/EventBoardPage/EventBoardPage",
      function () {
        return require("private-next-pages/events/EventBoardPage/EventBoardPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/EventBoardPage/EventBoardPage"])
      });
    }
  